goog.provide("shadow.js.shim.module$src$svg$shapes$other$traingle_fill_down_svg$default");
shadow.js.shim.module$src$svg$shapes$other$traingle_fill_down_svg$default = shadow.js.shim.module$src$svg$shapes$other$traingle_fill_down_svg.default;
